<template>

    <Head>
        <meta name="title" content="Vocabulario de Inglés Nivel A1 | 1000 Palabras con Quiz + Pronunciaciones" />
        <title>Vocabulario de Inglés Nivel A1 | 1000 Palabras con Quiz + Pronunciaciones</title>
        <meta name="description"
            content="Puedes aprender palabras en inglés de nivel A1 con un quiz aquí. La lista consiste en 1000 palabras. Haz clic en el ícono de sonido para escuchar la pronunciación de las palabras." />
    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">Vocabulario de Inglés Nivel A1 | Aprende 1000 Palabras con Quiz + Escucha las
                    Pronunciaciones</h1>

                <p class="mt-5">Hola, en este artículo de blog, estamos compartiendo <b>vocabulario de inglés de nivel
                        A1</b> contigo.
                    Aprender estas palabras impactará positivamente tus habilidades de lectura, escucha, escritura e
                    incluso
                    habla en inglés. Dado que estas son <b>las palabras más comúnmente usadas en inglés</b>, aprenderlas
                    te
                    ayudará a comprender muchas frases básicas en inglés.</p>

                <p>En la lista de abajo, hemos proporcionado cada palabra junto con su significado. <b>Nuestra lista
                        consiste en 1,000
                        palabras.</b> También hemos asignado a cada palabra un nivel de dificultad del 1 al 9. Puedes
                    filtrar las
                    palabras por dificultad usando la barra de dificultad. Al hacer clic en el ícono de sonido junto a
                    cada palabra,
                    puedes <b>escuchar su pronunciación.</b> Además, puedes hacer clic en las palabras que ya sabes para
                    eliminarlas
                    de la lista. Una vez que termines de eliminar las palabras conocidas, puedes comenzar el Quiz de
                    Palabras haciendo
                    clic en el botón "Ir al Quiz".</p>

                <p>La inteligencia artificial desarrollada por Diziyle Öğren ha escaneado más de 60 series de TV y
                    películas en inglés
                    para identificar estas palabras esenciales y comúnmente usadas. <b>La lista de abajo consiste en
                        palabras de inglés
                        de nivel A1.</b> A medida que analizamos más series y películas, nuestra lista se actualiza
                    automáticamente.
                    Pronto compartiremos una entrada de blog con listas de palabras más desafiantes. Para ser notificado
                    cuando se
                    publique, puedes seguirnos en las redes sociales.</p>

                <p>Dado que puedes estudiar la lista de palabras con el Quiz a continuación, no hemos compartido un
                    archivo PDF. Sin
                    embargo, si solicitas la lista de palabras en formato PDF desde nuestra página de contacto, <b>te
                        enviaremos el
                        PDF a tu dirección de correo electrónico.</b> Esperamos ser útiles en tu viaje de aprendizaje de
                    inglés.
                    ¡Felices estudios 😊</p>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>
                <h2 class="archivo mt-4"> Lista de Palabras de Inglés Nivel A1 </h2>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 943, MeanLanguageType: 3 } }).then((response) => {
            this.wordListData = JSON.parse(JSON.stringify(response.data))

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
}

</script>